import { Descriptions } from "antd";
import dayjs from "dayjs";
import { useFormikContext } from "formik";
import { ControlcenterMelcoModelsPaymentListItem, ControlcenterMelcoModelsPaymentTransDetails, InputField, TextAreaField, VerticalForm } from "melco-shared-logic";
import { Button, Space, SaveIcon, Title, Text, Table } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Status } from "./PaymentsList";
import { useState } from "react";
import { FormattedDate } from "../../table/FormattedDate";
import JsonViewer from "../../../helper/jsonViewer";
import { removeExtension } from "../../../helper/files";
import { isEmpty } from "lodash-es";

const Left = styled(Space)`
  display: flex;
  flex-direction: column;
  
`;

type DisplayProcessPaymentFormProps = {
  processPaymentDetails: ControlcenterMelcoModelsPaymentTransDetails | undefined;
  setSubmitPaymentStatus: (n: number | undefined) => void
};

export const DisplayProcessPaymentForm: React.FC<
  DisplayProcessPaymentFormProps
> = ({
  processPaymentDetails,
  setSubmitPaymentStatus
}) => {
    const { t } = useTranslation();
    const { isSubmitting, submitForm } = useFormikContext();
    const [submittingButton, setSubmittingButton] = useState("")
    console.log(JSON.stringify(processPaymentDetails))

    const historyColumns = [
      {
        title: t("payments.drawer.history.table.name"),
        key: "name",
        //dataIndex: "name",
        // sorter: true,
        width: 70,
        render: (rowObj: any) => (<>{
          removeExtension(rowObj?.name)
        }</>)
      },
      {
        title: (t("payments.drawer.history.table.modified_date")),
        key: "modified_date",
        // dataIndex: "product_level_code",
        // sorter: true,
        width: 50,
        render: (rowObj: any) => (<FormattedDate date={rowObj?.modified_date} />)
      },
      {
        title: (t("payments.drawer.history.table.json")),
        key: "json",
        //dataIndex: "json",
        //sorter: true,
        width: 130,
        // render: (rowObj: any) => {
        //   // Safely parse the JSON string, then re-stringify with indentation.
        //   // JSON.stringify(parsed, null, 2) — the "2" is the indent spaces.
        //   // We wrap in try/catch because user-supplied JSON strings can be malformed.
        //   try {
        //     //const parsed = typeof rowObj?.json === 'string' ? JSON.parse(rowObj.json) : rowObj.json;
        //     return (
        //       <pre style={{ margin: 0, fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        //         {rowObj.json}
        //       </pre>
        //     );
        //   } catch {
        //     // Fallback: show raw value so data is never silently lost
        //     return <span style={{ color: 'red' }}>{rowObj.json}</span>;
        //   }
        // },
        render: (rowObj: any) => <JsonViewer data={rowObj?.json} />
      },

    ]
    return (
      <>
        <div>


          {processPaymentDetails && (
            // <StyledDescriptionsDiv>
            <>

              <Title level={4}>{t("payments.drawer.heading")}</Title>

              <Descriptions
                bordered
                column={4}
                size="small"
              >
                <Descriptions.Item
                  label={<Text>{t("payments.table.column.melco_customer_id")}</Text>}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={2}
                >
                  <Text>{processPaymentDetails?.melco_customer_id ?? ""}</Text>
                </Descriptions.Item>

                <Descriptions.Item
                  label={<Text>{t("payments.table.column.user_name")}</Text>}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={2}
                >
                  <Text>{processPaymentDetails?.user_name ?? ""}</Text>
                </Descriptions.Item>

                <Descriptions.Item
                  label={<Text>{t("payments.table.column.product_code")}</Text>}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={2}
                >
                  <Text>{processPaymentDetails?.product_code ?? ""}</Text>
                </Descriptions.Item>

                <Descriptions.Item
                  label={<Text>{t("payments.table.column.product_level_code")}</Text>}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={2}
                >
                  <Text>{processPaymentDetails?.product_level_code ?? ""}</Text>
                </Descriptions.Item>

                <Descriptions.Item
                  label={<Text>{t("payments.table.column.payment_entry_date")}</Text>}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={2}
                >
                  <Text>{(processPaymentDetails?.payment_entry_date) ? dayjs(processPaymentDetails?.payment_entry_date).format("MM/DD/YYYY") : ""}</Text>
                </Descriptions.Item>

                <Descriptions.Item
                  label={<Text>{t("payments.table.column.processing_date")}</Text>}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={2}
                >
                  <Text>
                    {(processPaymentDetails?.processing_date) ? dayjs(processPaymentDetails?.processing_date).format("MM/DD/YYYY") : ""}</Text>
                </Descriptions.Item>

                <Descriptions.Item
                  label={<Text>{t("payments.table.column.price")}</Text>}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={2}
                >
                  <Text>{"$" + processPaymentDetails?.price}</Text>
                </Descriptions.Item>

                <Descriptions.Item
                  label={<Text>{t("payments.table.column.qty")}</Text>}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={2}
                >
                  <Text>{processPaymentDetails.qty}</Text>
                </Descriptions.Item>

                <Descriptions.Item
                  label={<Text>{t("payments.table.column.amount")}</Text>}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={2}
                >
                  <Text>{"$" + processPaymentDetails.amount}</Text>
                </Descriptions.Item>

                <Descriptions.Item
                  label={<Text>{t("payments.table.column.payment_amount")}</Text>}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={2}
                >
                  <Text>{processPaymentDetails.payment_status === 1 ? "" : "$" + processPaymentDetails.payment_amount}</Text>
                </Descriptions.Item>



                <Descriptions.Item
                  label={<Text>{t("payments.table.column.service_start_date")}</Text>}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={2}
                >
                  <Text>{processPaymentDetails?.service_start_date ? dayjs(processPaymentDetails?.service_start_date).format("MM/DD/YYYY") : ""}</Text>
                </Descriptions.Item>

                <Descriptions.Item
                  label={<Text>{t("payments.table.column.service_end_date")}</Text>}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={2}
                >
                  <Text>{processPaymentDetails?.service_end_date ? dayjs(processPaymentDetails?.service_end_date).format("MM/DD/YYYY") : ""}</Text>
                </Descriptions.Item>



                <Descriptions.Item
                  label={<Text>{t("payments.table.column.payment_status")}</Text>}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={2}
                >
                  <Text>{processPaymentDetails?.payment_status ? Status[processPaymentDetails?.payment_status] : t("payments.table.unknown")}</Text>
                </Descriptions.Item>
                <Descriptions.Item
                  label={""}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={2}
                >
                  <Text>{""}</Text>
                </Descriptions.Item>
                <Descriptions.Item
                  label={<Text>{t("payments.table.column.description")}</Text>}
                  labelStyle={{ backgroundColor: "#ffffff" }}
                  span={4} // Description might be long, so span full row
                >
                  <Text>{processPaymentDetails?.desc ?? ""}</Text>
                </Descriptions.Item>
              </Descriptions>
              {/* History table*/}
              <div style={{ margin: "30px 0px" }}>
                <Title level={5}>{t("payments.drawer.history.title")}</Title>
                <Table
                  showSorterTooltip={false}
                  sticky
                  //  loading={isPreviousData ? isFetching : isLoading}
                  dataSource={processPaymentDetails?.api_history_list ?? []}
                  columns={historyColumns}
                  //onChange={onTableConfigChange}
                  // pagination={pagination}
                  rowKey="id"
                  // rowSelection={rowSelection}
                  // onRow={onRow}
                  noDataMessage={("No payment history available")}
                  pagination={false}
                  style={{ marginTop: "10px", marginBottom: "10px" }}
                // errorComponent={errorComponent}
                // scroll={{ x: 'max-content' }}
                />
              </div>
            </>
            // </StyledDescriptionsDiv>
          )}


          <VerticalForm>

            <InputField
              name="id"

              value={processPaymentDetails?.id ? processPaymentDetails.id : ""}
              hidden
            />
            <InputField
              name="transaction_id"
              label={t("payments.table.column.transaction_id")}
              value={processPaymentDetails?.transaction_id ? processPaymentDetails.transaction_id : "EMpty"}
            />
            <InputField
              name="payment_amount"
              type="number"
              label={t("payments.table.column.payment_amount")}
              value={processPaymentDetails?.payment_amount ? Number(processPaymentDetails.payment_amount) : 0}
            />
            <TextAreaField
              name="comments"
              label={t("payments.table.column.comments")}
              showCount
              maxLength={500}
              rows={4}
              value={processPaymentDetails?.comments ? processPaymentDetails.comments : ""} />
          </VerticalForm>
          <Left direction="vertical" size="small">
            <Button
              icon={<SaveIcon />}
              type="primary"
              disabled={processPaymentDetails?.payment_status !== 1}
              loading={isSubmitting && submittingButton === "process_payment"}
              onClick={() => {
                setSubmittingButton("process_payment")
                setSubmitPaymentStatus(2)
                submitForm();
              }}
              style={{ marginBottom: "15px" }}
            >
              {t("payments.actions.process.buttons.process_payment")}
            </Button>
            <Button
              icon={<SaveIcon />}
              type="primary"
              disabled={processPaymentDetails?.payment_status !== 1}
              loading={isSubmitting && submittingButton === "archive_payment"}
              onClick={() => {
                setSubmittingButton("archive_payment")
                setSubmitPaymentStatus(3)
                submitForm();
              }}
              style={{ marginBottom: "15px" }}
            >
              {t("payments.actions.process.buttons.archive_payment")}
            </Button>
          </Left>
        </div>
      </>
    );
  };
